module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/appComponent.html
// module id = 1180
// module chunks = 0